var map = {
	"./black/zidongjieting2.png": "OtzO",
	"./blue/zidongjieting2.png": "BCH4",
	"./white/zidongjieting2.png": "v8ME"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Q5kx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/zidongjieting2\.png$
// module id = Q5kx
// module chunks = 24